import '../../styles/sections/marquee.scss';

class CustomMarquee extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    // Need this funtional wrapper so that its contents run right before next paint
    // Necessary because of the loading order of iframes (theme editor)
    requestAnimationFrame(() => {
      this.content = this.querySelector('[data-marquee-content]');
      this.marqueeItems = this.querySelectorAll('[data-marquee-item]');
      this.initializeMarquee();

      // Resize listener
      this.handleResize = this.debounce(() => this.reinitialize(), 200);
      window.addEventListener('resize', this.handleResize);
    });
  }

  reinitialize() {
    // Stop/pause animation
    this.classList.remove('animate-marquee');

    // Remove existing clones
    this.querySelectorAll('.marquee__item--clone, .marquee__content--clone').forEach(element => element.remove());
    this.initializeMarquee();
  }


  initializeMarquee() {
    if (!this.content || this.marqueeItems.length === 0) return;

    // if content is smaller than container, duplicate content until it fills the container
    if (this.content.offsetWidth < this.offsetWidth) {
      const cloneCount = Math.ceil(this.offsetWidth / this.content.offsetWidth);

      for (let i = 0; i < cloneCount; i++) { //clone marquee items
        this.marqueeItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.removeAttribute('data-marquee-item');
          clone.classList.add('marquee__item--clone');
          clone.setAttribute('aria-hidden', 'true');
          this.content.appendChild(clone);
        });
      }
    }

    // clone content
    const clone = this.content.cloneNode(true);
    clone.removeAttribute('data-marquee-content');
    clone.classList.add('marquee__content--clone');
    clone.setAttribute('aria-hidden', 'true');
    this.appendChild(clone);

    // add the animation class to only launch the animation when the marquee is ready
    this.classList.add('animate-marquee');
  }

  debounce(functionToLimit, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => functionToLimit.apply(this, args), wait);
    };
  }

  disconnectedCallback() {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
  }
}

try {
  customElements.define('custom-marquee', CustomMarquee);
} catch (e) {}
